import { SET_COMPLAINT_NUMBER as type } from '.';

export default payload => ({
  type,
  payload,
});
